/**
 * Joins a configuration-tree node id to its parent's.
 *
 * Entity ids are only unique within their parent — the same cluster can exist in two
 * accounts — so node ids are parent-qualified. `~` is unreserved in RFC 3986, so it needs
 * no encoding in the `/settings/configurations/:nodeId` path segment, and it cannot
 * appear in an AWS account id, EKS cluster name, or `i-`/`vol-` id.
 *
 * Lives in its own module so `utils.ts` and `transformConfigResponse.ts` can both use it
 * without importing each other.
 */
export const nodeIdSeparator = '~';

/** The trailing entity id of a parent-qualified node id. */
export function getEntityIdFromNodeId(nodeId: string): string {
  return nodeId.split(nodeIdSeparator).at(-1) ?? nodeId;
}
